import {
  ADD_PAYMENT_PURPOSE_REQUEST,
  ADD_PAYMENT_PURPOSE_SUCCESS,
  ADD_PAYMENT_PURPOSE_FAILURE,
  FETCH_PAYMENT_PURPOSES_REQUEST,
  FETCH_PAYMENT_PURPOSES_SUCCESS,
  FETCH_PAYMENT_PURPOSES_FAILURE,
  UPDATE_PAYMENT_PURPOSES_REQUEST,
  UPDATE_PAYMENT_PURPOSES_SUCCESS,
  UPDATE_PAYMENT_PURPOSES_FAILURE,
  DELETE_PAYMENT_PURPOSES_REQUEST,
  DELETE_PAYMENT_PURPOSES_SUCCESS,
  DELETE_PAYMENT_PURPOSES_FAILURE,
  CLEAR_PAYMENT_PURPOSES_ERROR,
} from "../actions/paymentPurposeActionTypes";

const initialState = {
  paymentPurposes: [],
  isLoading: false,
  addPaymentPurposeError: null,
  fetchPaymentPurposesError: null,
  updatePaymentPurposeError: null,
};

const paymentPurposeReducer = (state = initialState, action) => {
  //switch (action.type) {
  // Generic loading state for all request actions
  switch (action.type) {
    case ADD_PAYMENT_PURPOSE_REQUEST:
      return {
        ...state,
        isLoading: true,
        addPaymentPurposeError: null,
      };

    case ADD_PAYMENT_PURPOSE_SUCCESS:
      return {
        ...state,
        paymentPurposes: [...state.paymentPurposes, action.payload],
        isLoading: false,
        addPaymentPurposeError: null,
      };

    case ADD_PAYMENT_PURPOSE_FAILURE:
      return {
        ...state,
        isLoading: false,
        addPaymentPurposeError: action.payload,
      };

    case FETCH_PAYMENT_PURPOSES_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          [action.type.replace("_REQUEST", "").toLowerCase()]: null,
        },
      };

    // Handle fetch payment purposes success
    case FETCH_PAYMENT_PURPOSES_SUCCESS:
      console.log("Updated paymentPurposes:", action.payload);
      return {
        ...state,
        isLoading: false,
        paymentPurposes: action.payload,
        errors: { ...state.errors, fetchPaymentPurposes: null },
      };

    case FETCH_PAYMENT_PURPOSES_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          fetchPaymentPurposes: action.payload || "An error occurred.",
        },
      };

    case UPDATE_PAYMENT_PURPOSES_REQUEST:
      return {
        ...state,
        isLoading: true,
        updatePaymentPurposeError: null,
      };

    case UPDATE_PAYMENT_PURPOSES_SUCCESS:
      return {
        ...state,
        paymentPurposes: state.paymentPurposes.map((purpose) =>
          purpose.id === action.payload.id ? action.payload : purpose,
        ),
        isLoading: false,
        updatePaymentPurposeError: null,
      };

    case UPDATE_PAYMENT_PURPOSES_FAILURE:
      return {
        ...state,
        isLoading: false,
        updatePaymentPurposeError: action.payload,
      };

    // Clear all errors
    case CLEAR_PAYMENT_PURPOSES_ERROR:
      return {
        ...state,
        errors: {
          fetchPaymentPurposes: null,
        },
      };

    // Default state
    default:
      return state;
  }
};

export default paymentPurposeReducer;
